import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Api } from '../../api'
import type { Feature } from '../feature'

/** Loads the agents and data sources available for document management. */
export const executeLoad = store.effects.create((feature: Feature, api: Api) =>
  feature.actions.load.request.observe().pipe(
    rxjs.exhaustMap(action =>
      api.getManagement().pipe(
        rxjs.map(response =>
          feature.actions.load.success.from(action).create({
            request: action.data,
            response,
          }),
        ),
        rxjs.catchError((error: Error) =>
          rxjs.of(
            feature.actions.load.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      ),
    ),
  ),
)
